import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing';
import { formatCurrency } from 'utils';
import { calculateSubsidyBreakdown } from '../../lib';
import { SubsidyTableRow } from '../../types';

interface Props {
  rowIndex: number;
  storedValue?: number;
  subsidyPercent: number;
  dnetCoefficient: number;
  dealerParticipationPercent: number;
}

export const ApprovedSubsidyCell = ({
  rowIndex,
  storedValue,
  subsidyPercent,
  dnetCoefficient,
  dealerParticipationPercent,
}: Props) => {
  const { control } = useFormContext<ListingForm<SubsidyTableRow>>();

  const row = useWatch({ control, name: `bodyFields.${rowIndex}` });

  const approvedSubsidyAmount = useMemo(() => {
    if (storedValue !== undefined) return storedValue;

    const { approvedSubsidyAmount } = calculateSubsidyBreakdown({
      subsidyPercent,
      dnetCoefficient,
      dnet: row?.dnet ?? 0,
      dealerParticipationPercent,
      financeAmount: row?.financeAmount ?? 0,
    });

    return approvedSubsidyAmount;
  }, [storedValue, row?.dnet, row?.financeAmount, subsidyPercent, dnetCoefficient, dealerParticipationPercent]);

  return <Typography fontWeight={500}>{formatCurrency(approvedSubsidyAmount, true)}</Typography>;
};
